// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Q1em","footer":"ModalInfo_footer__Ww6x3"};